import { useState, useRef } from 'react';
import { loginWithGoogle, useAuth } from 'src/utils';
import { useGoogleLogin } from '@react-oauth/google';
import '../profile.css';
import { Typography, Box, Button, GoogleIcon } from 'src/components';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { Capacitor } from '@capacitor/core';

export default function GoogleAuthButton({ setLoading, handleCurrentViewChange, handleSuccess, showButtonText=true }) {
  const [errorMsg, setErrorMsg] = useState('');
  const timer = useRef();
  const { loginUser } = useAuth();

  // Web login
  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setErrorMsg('');

    const googleToken = credentialResponse.access_token;

    timer.current = window.setTimeout(async () => {
      try {
        const res = await loginWithGoogle(googleToken);
        loginUser(res.token, res.refreshToken);
        handleSuccess('Logged in with Google!');
        handleCurrentViewChange('AccountSummary');
      } catch (err) {
        setErrorMsg(err.message || 'Google login failed');
      } finally {
        setLoading(false);
      }
    }, 1000);
  };

  const loginWeb = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => setErrorMsg('Google login failed'),
  });

  // Native login
  const handleNativeLogin = () => {
    setLoading(true);
    setErrorMsg('');

    SocialLogin.login({
      provider: 'google',
      options: { scopes: ['email', 'profile'] },
    })
      .then(async (res) => {
        console.log('SIGN IN RESULT', JSON.stringify(res, null, 2));

        const accessToken = res?.result?.accessToken?.token;

        const { givenName, familyName } = res.result?.profile || {};
        const fullName = [givenName, familyName].filter(Boolean).join(' ');

        console.log('Gogle full name:', fullName);

        if (!accessToken) {
          throw new Error('No access token returned from Google login');
        }

        const backendResult = await loginWithGoogle(accessToken, fullName);
        loginUser(backendResult.token);
        handleSuccess('Logged in with Google!');
        handleCurrentViewChange('AccountSummary');
      })
      .catch((err) => {
        console.log('Social login failed', err);
        setErrorMsg(err.message || 'Google login failed');
      })
      .finally(() => setLoading(false));
  };

  const handleLogin = () => {
    const platform = Capacitor.getPlatform();

    if (platform === 'web') {
      loginWeb(); // Web flow
    } else {
      handleNativeLogin(); // Native flow
    }
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          fullWidth
          variant="outlined"
          onClick={handleLogin}
          sx={{
            borderRadius: 1,
            position: 'relative',
            justifyContent: 'center',
            backgroundColor: 'white',
            color: '#6d6d6dff',
            borderColor: '#ccc',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: '#999',
            },
            '& .MuiButton-startIcon': {
              position: 'absolute',
              left: 22,
              marginRight: 0,
            },
          }}
          startIcon={showButtonText ? <GoogleIcon /> : null}
        >
          {showButtonText ? <>Continue with Google</> : <GoogleIcon />}
        </Button>
      </Box>

      {errorMsg && <Typography variant="body3" color="error">{errorMsg}</Typography>}
    </>
  );
}
